import { apiClient } from '~/lib/api/client';

export interface UserRoleRef {
  id: string;
  name: string;
}

/** Response from GET /users/me (current user + permissions). */
export interface UserProfile {
  id: string;
  username?: string;
  email?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  user_role?: UserRoleRef;
  /** Raw permission strings from API; may mix spaces and underscores. */
  permissions?: string[];
  roles?: string[];
  role?: string;
  jobTitle?: string;
  lastLoginAt?: string;
  createdAt?: string;
  regional_code?: string | null;
}

export const getCurrentUserProfile = async (): Promise<UserProfile> => {
  const response = await apiClient.get<UserProfile>('/users/me');
  return response.data;
};
